import { COLORS } from 'helpers/globals'

const handle = {
  position: 'absolute',
  marginLeft: -8,
  marginTop: -5,
  width: 15,
  height: 15,
  cursor: 'pointer',
  borderRadius: 15,
  border: `solid 1px ${COLORS.primary}`,
  background: '#fff',
  color: 'black'
}

export default {
  InfraredRange: {
    width: '100%',
    padding: '0 1rem 0 1rem'
  },
  handle,
  disabledHandle: {
    ...handle,
    borderColor: COLORS.secondary
  },
  display: {
    textAlign: 'center',
    fontSize: '1.3rem',
    lineHeight: '1.3rem'
  },
  disabled: {
    '& .rc-slider-track': {
      background: COLORS.secondary
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/Filter/InfraredRange/style.js